import { BaseModel } from '../base.model';

export interface Retail extends BaseModel {
    shipmentLine?:any;
    scode?:any;
}

export const defaultRetail: Readonly<Retail> = {};